import "core-js/modules/es.promise.finally.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useState } from 'react';
import { StandardButton } from '@eika/button';
import { ErrorCard } from '@eika/card';
import { Input } from '@eika/input';
import { ExpandableRadioButtons } from '@eika/radio-button';
import restClient from '../../restClient';
import OverlayLoader from '../overlay-loader';
export const ConfirmActors = _ref => {
  let {
    actors,
    onConfirmed
  } = _ref;
  const [selectedOption, setSelectedOption] = useState(undefined);
  const [confirmed, setConfirmed] = useState(undefined);
  const [comment, setComment] = useState();
  const [valid, setValid] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(undefined);
  const confirmedOption = {
    value: 'Jeg bekrefter at informasjonen over er korrekt'
  };
  const rejectedOption = {
    value: 'Informasjonen over er ikke korrekt',
    expandContent: /*#__PURE__*/React.createElement(Input, {
      name: "comment",
      label: "Beskriv hva som ikke stemmer",
      value: comment,
      onChange: e => setComment(e.target.value),
      required: true,
      error: comment && !valid && 'Du må skrive minst 10 bokstaver'
    })
  };
  const options = [confirmedOption, rejectedOption];
  useEffect(() => {
    if (selectedOption === undefined) return;
    const confirmed = selectedOption === confirmedOption.value;
    if (confirmed) setConfirmed(() => ({
      typeInfo: 'CONFIRMED'
    }));else setConfirmed(() => ({
      typeInfo: 'REJECTED_WITH_COMMENT',
      comment: comment || ''
    }));
  }, [comment, confirmedOption.value, selectedOption]);
  useEffect(() => {
    const userConfirmed = (confirmed === null || confirmed === void 0 ? void 0 : confirmed.typeInfo) === 'CONFIRMED';
    const userRejected = (confirmed === null || confirmed === void 0 ? void 0 : confirmed.typeInfo) === 'REJECTED_WITH_COMMENT' && confirmed.comment.length >= 10;
    setValid(userConfirmed || userRejected);
  }, [confirmed, confirmed === null || confirmed === void 0 ? void 0 : confirmed.typeInfo]);
  const submitActorConfirmation = () => {
    if (confirmed === undefined || submitting) return;
    setSubmitting(true);
    setError(undefined);
    restClient.confirmCorporateActors({
      actors,
      answer: confirmed
    }).then(() => onConfirmed()).catch(reason => setError(reason)).finally(() => setSubmitting(false));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExpandableRadioButtons, {
    options: options,
    selectedOption: selectedOption,
    onChange: value => setSelectedOption(value),
    className: "margin-top-large"
  }), submitting && /*#__PURE__*/React.createElement(OverlayLoader, null), /*#__PURE__*/React.createElement(StandardButton, {
    className: "progress-next-button",
    type: "submit",
    disabled: confirmed === undefined || submitting || !valid,
    onClick: submitActorConfirmation
  }, "Neste"), error && /*#__PURE__*/React.createElement(ErrorCard, {
    title: "Noe gikk galt!",
    description: /*#__PURE__*/React.createElement("p", null, "Vi kunne ikke lagre svarene dine. Vennligst pr\xF8v igjen senere eller kontakt banken dersom problemene vedvarer. Referanse: ", error.rcid)
  }));
};